import React from 'react';
import { useSelector } from 'react-redux';
import {
  bikeColourSelector,
  getPendingAccessories,
  getConflictingAccessories,
  getConflictChoice,
  getPendingPack,
  getPendingPackConflicts,
  getPack,
  getRequiresSingleChoice,
  getRequiresAccessories,
  getPreviewedPack,
  getPackTotal,
  getBikeAccessories,
  getPreviewedPackTotal,
  getPackPendingRemoval,
  getPendingConflictingAccessories,
  getSelectedWarrantyPack,
  getSelectedServicePack,
} from 'src/redux/bike/selectors';

const useBikeTotal = () => {
  const colour = useSelector(bikeColourSelector);
  const accessories = useSelector(getBikeAccessories);
  const pendingAccessories = useSelector(getPendingAccessories);
  const conflictingAccessories = useSelector(getConflictingAccessories);
  const conflictChoice = useSelector(getConflictChoice);
  const pendingPack = useSelector(getPendingPack);
  const pendingPackConflicts = useSelector(getPendingPackConflicts);
  const selectedPack = useSelector(getPack);
  const previewedPack = useSelector(getPreviewedPack);
  const { requiresAll, requiresSingle } = useSelector(getRequiresAccessories);
  const requiresSingleChoice = useSelector(getRequiresSingleChoice);
  const packTotal = useSelector(getPackTotal);
  const previewedPackTotal = useSelector(getPreviewedPackTotal);
  const pendingAccessory = pendingAccessories[0];
  const packPendingRemoval = useSelector(getPackPendingRemoval);
  const pendingConflictingAccessories = useSelector(getPendingConflictingAccessories);
  const selectedWarrantyPack = useSelector(getSelectedWarrantyPack);
  const selectedServicePack = useSelector(getSelectedServicePack);

  let total = (colour && colour.price) || 0;

  total += accessories.reduce((prevTotal, accessory) => prevTotal + accessory.price * (accessory.quantity || 1), 0);

  if (selectedServicePack) {
    total += Number(selectedServicePack.price);
  }

  if (selectedWarrantyPack) {
    total += Number(selectedWarrantyPack.price);
  }

  if (pendingAccessories.length && !packPendingRemoval) {
    if (conflictingAccessories.length) {
      const conflictingAccessoriesTotal = conflictingAccessories.reduce(
        (prevTotal, accessory) => prevTotal + accessory.price * (accessory.quantity || 1),
        0
      );

      total -= conflictingAccessoriesTotal;

      if (conflictChoice === 'existing') {
        total += conflictingAccessoriesTotal;
      }

      if (conflictChoice === 'new') {
        total += pendingConflictingAccessories.reduce(
          (prevTotal, accessory) => prevTotal + accessory.price * (accessory.quantity || 1),
          0
        );
      }
    } else {
      if (requiresSingle.length || requiresAll.length) {
        total += pendingAccessory.price;
      }

      if (requiresSingle.length && requiresSingleChoice) {
        total += requiresSingleChoice.price;
      }

      if (requiresAll.length) {
        total += requiresAll.reduce((prevTotal, accessory) => prevTotal + accessory.price, 0);
      }
    }
  }

  if (pendingPack && pendingPack.isLocked) {
    const pendingPackConflictsTotal = pendingPackConflicts.reduce(
      (prevTotal, accessory) => prevTotal + accessory.price * (accessory.quantity || 1),
      0
    );

    total -= pendingPackConflictsTotal;

    if (conflictChoice === 'pack') {
      total += pendingPack.price;
    }

    if (conflictChoice === 'accessories') {
      total += pendingPackConflictsTotal;
    }
  }

  if (packPendingRemoval) {
    if (conflictChoice === 'pack') {
      total += packTotal;
    }

    if (conflictChoice === 'accessory') {
      total += pendingAccessories.reduce((prevTotal, accessory) => prevTotal + accessory.price, 0);
    }
  }

  if (selectedPack && !packPendingRemoval) {
    total += packTotal;
  }

  if (previewedPack && !selectedPack && !pendingPack) {
    total += previewedPackTotal;
  }

  return total;
};

export default useBikeTotal;
